export default "__VITE_ASSET__DICM_wtP__"